import { createSlice } from '@reduxjs/toolkit';

interface TranslateState {
    lastResetTime: number;
    translationCount: number;
}

const initialState: TranslateState = {
    lastResetTime: Date.now(),
    translationCount: 0,
};

const translateSlice = createSlice({
    name: 'translate',
    initialState,
    reducers: {
        incrementTranslationCount: (state) => {
            state.translationCount += 1;
        },
        resetTranslationCount: (state) => {
            state.translationCount = 0;
            state.lastResetTime = Date.now();
        },
    },
});

export const translateActions = translateSlice.actions;
export default translateSlice.reducer;
